import HTMLReactParser from "html-react-parser";

const SocialWallLinks = () => {
  const sbySettings = window.sby_settings;

  if (sbySettings.socialWallActivated !== "1") {
    return null;
  }

  return (
    <div className="sb-social-wall-link-wrap">
      {sbySettings.socialWallLinks.map((link, index) => {
        return (
          <div key={index} className="sb-social-wall-link">
            {HTMLReactParser(link)}
          </div>
        );
      })}
    </div>
  );
};

export default SocialWallLinks;
